import { render, staticRenderFns } from "./shareButton.vue?vue&type=template&id=37ed19ca&scoped=true&"
import script from "./shareButton.vue?vue&type=script&lang=js&"
export * from "./shareButton.vue?vue&type=script&lang=js&"
import style0 from "./shareButton.vue?vue&type=style&index=0&id=37ed19ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed19ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
